export const MAIL_TO = 'yurik-007@mail.ru'
export const PHONE = '+7 9854304418'
export const ADDRESS = 'Россия, Москва'
